import { render, staticRenderFns } from "./NarliFerryboatStatsByVehicleTypeView.vue?vue&type=template&id=3e1ad8e9&"
import script from "./NarliFerryboatStatsByVehicleTypeView.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByVehicleTypeView.vue?vue&type=script&lang=js&"
import style0 from "./NarliFerryboatStatsByVehicleTypeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports